// Color constants for export components
export const EXPORT_COLORS = {
  primary: 'rgb(13, 138, 106)',
  secondary: '#6c757d',
  text: '#333',
  border: '#e5e5e5',
  error: '#dc3545',
  errorBg: 'rgba(220, 53, 69, 0.1)',
  hover: '#f8f9fa',
  infoBg: '#e8f4fd',
  infoText: '#0c63e4',
  errorLightBg: '#fef2f2'
};
